import {TextInput} from "../../Components/Form/TextInput";
import {SecondaryButton} from "../../Components/Buttons/SecondaryButton";
import {BaseCard} from "../../Components/Cards/BaseCard";
import {useBoundStore} from "../../Store/store";
import {useEffect, useState} from "react";
import {InvoicesTable} from "../../Components/Tables/TableCards/InvoicesTable";
import {useTranslation} from "react-i18next";

export const MyInvoices = () => {
    const {t} = useTranslation();
    const invoices = useBoundStore((state) => state.invoices)
    const getMyInvoices = useBoundStore((state) => state.getMyInvoices)
    const markInvoiceAsPaid = useBoundStore((state) => state.markInvoiceAsPaid)
    const [statusFilter, setStatusFilter] = useState([]);
    const [forceNewData, setForceNewData] = useState(false);
    const [searchFilter, setSearchFilter] = useState('');

    const handleFilterClick = (status) => {
        if(statusFilter.includes(status)) {
            setStatusFilter(statusFilter.filter(s => s !== status))
        } else {
            setStatusFilter([...statusFilter, status])
        }
    }

    const handleMarkAsPaid = async (invoiceId) => {
        const success = await markInvoiceAsPaid(invoiceId);
        if (success) {
            getMyInvoices(statusFilter, searchFilter);
        }
    };

    useEffect(() => {
        setForceNewData(!forceNewData);
    }, [invoices]);

    useEffect(() => {
        getMyInvoices(statusFilter, searchFilter)
    }, [getMyInvoices, statusFilter, searchFilter]);

    return (
        <div>
            <div className={'mb-2 '}>
                <div className={'flex justify-between'}>
                    <div className={'my-auto'}>
                        <TextInput
                            type={'text'}
                            name={'search'}
                            translationIndex={null}
                            placeholder={t('general.actions.search')}
                            onChange={(e) => setSearchFilter(e.target.value)}
                        >
                        </TextInput>
                    </div>
                    <div className={'grid grid-cols-2 gap-4 my-auto'}>
                        <div>
                            <SecondaryButton outlined={!statusFilter.includes('pending')} onClick={() => {
                                handleFilterClick('pending')
                            }}>
                                {t('invoices.filter_unpaid')}
                            </SecondaryButton>
                        </div>
                        <div>
                            <SecondaryButton outlined={!statusFilter.includes('paid')} onClick={() => {
                                handleFilterClick('paid')
                            }}>
                                {t('invoices.filter_paid')}
                            </SecondaryButton>
                        </div>
                    </div>
                </div>
            </div>
            <BaseCard>
                <InvoicesTable
                    invoices={invoices}
                    forceNewData={forceNewData}
                    onMarkAsPaid={handleMarkAsPaid}
                />
            </BaseCard>
        </div>
    )
}